import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Instagram, Facebook, Clock } from "lucide-react";

const Footer = () => (
  <footer className="mt-24 pt-16 pb-10" style={{ background: "var(--sage-700)", color: "var(--cream)" }} data-testid="footer">
    <div className="max-w-7xl mx-auto px-6">
      {/* ==== FOOTER COLUMNAS ==== */}
      <div className="grid md:grid-cols-12 gap-10">
        {/* Brand column */}
        <div className="md:col-span-3">
          <img src="https://customer-assets.emergentagent.com/job_optometry-hub-4/artifacts/sy6zuzxz_S%20y%20V.jpg" alt="S y V" className="h-16 w-16 object-contain mb-4" style={{ mixBlendMode: "screen", filter: "brightness(0) invert(1) opacity(0.95)" }} />
          <img src="/brand/logo.jpg" alt="Salud y Visión" className="h-20 object-contain" style={{ mixBlendMode: "screen", filter: "brightness(0) invert(1) opacity(0.9)" }} />
          <p className="font-sans-body text-xs mt-4 opacity-70">CIF: B84738897</p>
          <div className="flex gap-3 mt-5">
            <a href="https://www.facebook.com/centrosaludyvision" target="_blank" rel="noopener noreferrer" aria-label="Facebook · Salud y Visión" className="opacity-75 hover:opacity-100 transition-opacity" data-testid="footer-facebook"><Facebook size={20} /></a>
            <a href="https://www.instagram.com/terapiavisualsaludyvision/" target="_blank" rel="noopener noreferrer" aria-label="Instagram · Salud y Visión" className="opacity-75 hover:opacity-100 transition-opacity" data-testid="footer-instagram"><Instagram size={20} /></a>
          </div>
        </div>

        {/* Madrid */}
        <div className="md:col-span-3 font-sans-body">
          <h4 className="text-sm uppercase tracking-widest mb-4 opacity-80">Madrid</h4>
          <p className="flex gap-2 items-start text-sm mb-3"><MapPin size={16} className="mt-0.5 shrink-0" /> <span>C/ Alcalde López Casero 10<br />Madrid</span></p>
          <p className="flex gap-2 items-start text-sm mb-3"><Phone size={16} className="shrink-0 mt-0.5" /> <span><span className="opacity-70">General</span> 91 404 48 77 <span className="opacity-70">· Terapia visual</span> 657 95 78 21 <span className="opacity-70">· Óptica</span> 640 81 23 28</span></p>
          <p className="flex gap-2 items-start text-sm"><Clock size={16} className="mt-0.5 shrink-0" /> <span>L–V · 10:00–14:30 y 16:30–20:00<br />Sáb · 10:15–14:00</span></p>
        </div>

        {/* Alcobendas */}
        <div className="md:col-span-3 font-sans-body">
          <h4 className="text-sm uppercase tracking-widest mb-4 opacity-80 flex items-center gap-2">
            Alcobendas
          </h4>
          <p className="flex gap-2 items-start text-sm mb-3"><MapPin size={16} className="mt-0.5 shrink-0" /> <span>Paseo de Fuente Lucha 5<br />28100 Alcobendas</span></p>
          <p className="flex gap-2 items-start text-sm mb-3"><Phone size={16} className="shrink-0 mt-0.5" /> <span><span className="opacity-70">General</span> 91 519 87 87 <span className="opacity-70">· Terapia visual</span> 657 95 78 21 <span className="opacity-70">· Óptica</span> 629 35 34 59</span></p>
          <p className="flex gap-2 items-start text-sm"><Clock size={16} className="mt-0.5 shrink-0" /> <span>L–V · 10:00–14:00 y 16:30–20:00<br />Sáb · 10:30–14:00</span></p>
        </div>

        {/* Enlaces + contacto */}
        <div className="md:col-span-3 font-sans-body">
          <h4 className="text-sm uppercase tracking-widest mb-4 opacity-80">Enlaces</h4>
          <ul className="space-y-2 text-sm mb-5">
            <li><Link to="/" className="hover:opacity-100 opacity-80">Inicio</Link></li>
            <li><Link to="/nosotros" className="hover:opacity-100 opacity-80">Nosotros</Link></li>
            <li><Link to="/servicios" className="hover:opacity-100 opacity-80">Servicios</Link></li>
            <li><Link to="/profesionales" className="hover:opacity-100 opacity-80">Para profesionales</Link></li>
            <li><Link to="/centros" className="hover:opacity-100 opacity-80">Nuestros centros</Link></li>
            <li><a href="/#contacto" className="hover:opacity-100 opacity-80">Contacto</a></li>
          </ul>
          <p className="flex gap-2 items-start text-sm break-all"><Mail size={16} className="mt-0.5 shrink-0" /> <span className="text-xs">centrodeoptometriasaludyvision@gmail.com</span></p>
        </div>
      </div>
    </div>
    <div className="max-w-7xl mx-auto px-6 mt-10 pt-6 border-t border-white/15 text-xs opacity-70 font-sans-body flex flex-wrap justify-between gap-3">
      <div>© {new Date().getFullYear()} Salud y Visión · Todos los derechos reservados</div>
      <div className="flex flex-wrap gap-4">
        <Link to="/aviso-legal" className="hover:opacity-100 opacity-85">Aviso legal</Link>
        <Link to="/politica-privacidad" className="hover:opacity-100 opacity-85">Política de privacidad</Link>
        <Link to="/politica-cookies" className="hover:opacity-100 opacity-85">Política de cookies</Link>
      </div>
    </div>
  </footer>
);

export default Footer;
